import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import { useLabels } from '../../hooks/useLabels';
import BillsEditor from './BillsEditor';

function AddBill() {
	const { t } = useLabels();
	const navigate = useNavigate();
	const { state } = useLocation();
	const returnTo = state?.returnTo || '/AdminScreen/assets';

	return (
		<EntityList>
			<Helmet>
				<title>{`Agregar ${t('entity.bill')}`}</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: t('entity.asset.plural'), to: '/AdminScreen/assets' },
					{ label: `Agregar ${t('entity.bill')}` },
				]}
				title={`Agregar ${t('entity.bill')}`}
				subtitle='Completá los datos para crear el gasto.'
			/>
			<BillsEditor
				mode='create'
				onCancel={() => navigate(returnTo)}
				onSaved={() => navigate(returnTo)}
				saveLabel='Agregar'
			/>
		</EntityList>
	);
}

export default AddBill;
